import { FC } from "react";

import { FormType } from "../../../gql/gql-types";
import { usePreviewContext } from "../../LiveFormEditor/LivePreview/context/PreviewContext";
import { useFormV2Context } from "../context/FormV2Context";

import { ThemedZeffyBusinessModelInfobox } from "@/features/FormV2/sharedComponents/ThemedZeffyBusinessModelInfobox";

export const FormV2ZeffyBusinessModelInfobox: FC = () => {
  const { isPreview } = usePreviewContext();
  const { type } = useFormV2Context();

  if (isPreview) {
    return null;
  }

  return <ThemedZeffyBusinessModelInfobox mode={type === FormType.Ticketing ? "ticketing" : "donation"} />;
};
